import type {
  Angebot, Belegung, Benutzer, Einstellungen, Ich, Job, Kunde, Kundennotiz,
  Position, Protokolle, Ressource, Rolle, Vorgang, Zahlungsziel,
} from "../typen";
/* **Nur Typen, kein Laufzeitkreis.** `routen.ts` fuehrt diese Datei ein;
   `import type` verschwindet beim Bauen und schliesst den Kreis nicht. */
import type { Maschinenstand, ProtokollZeile } from "../routen";

/* ══════════════════════════════════════════════════════════════════
   Die Beispieldaten des Prototyps.

   Wörtlich aus docs/artefakte/prototyp.html übernommen — dieselben
   Kunden, dieselben Kennungen, dieselbe KW 19. Damit sieht die
   Oberfläche im Attrappenmodus genauso aus wie die geprüfte Vorlage,
   und der Unterschied zum Betrieb ist eine Umgebungsvariable.

   **Keine Zahl hier ist ein Preis.** Alle Beträge stehen als `null`,
   bis die Kalkulation aus 04-preisfindung.md durchgeführt ist
   (CLAUDE.md, „Was ohne Rückfrage nicht gesetzt werden darf").
   ══════════════════════════════════════════════════════════════════ */

export const ICH: Ich = {
  id: "u-001",
  name: "Lisa Meyer",
  kurz: "LH",
  mail: "lisa@mr-machine.de",
  rollen: ["disposition", "buchhaltung", "verwaltung"],
  mandant: "Mr. Machine GmbH",
};

export const RESSOURCEN: Ressource[] = [
  { id: "RL-07", gruppe: "maschine", typ: "Radlader 5 t", kuerzel: "RL", kat: "Baumaschine" },
  { id: "RL-08", gruppe: "maschine", typ: "Radlader 5 t", kuerzel: "RL", kat: "Baumaschine" },
  { id: "RL-09", gruppe: "maschine", typ: "Radlader 5 t", kuerzel: "RL", kat: "Baumaschine" },
  { id: "RL-11", gruppe: "maschine", typ: "Radlader 5 t", kuerzel: "RL", kat: "Baumaschine" },
  { id: "RL-21", gruppe: "maschine", typ: "Radlader 6 t", kuerzel: "RL", kat: "Baumaschine" },
  { id: "KR-01", gruppe: "maschine", typ: "Autokran 30 t", kuerzel: "KR", kat: "Hebetechnik" },
  { id: "KR-02", gruppe: "maschine", typ: "Autokran 30 t", kuerzel: "KR", kat: "Hebetechnik" },
  { id: "MS-11", gruppe: "maschine", typ: "Minibagger 1,8 t", kuerzel: "MS", kat: "Baumaschine" },
  { id: "MS-14", gruppe: "maschine", typ: "Minibagger 1,8 t", kuerzel: "MS", kat: "Baumaschine" },
  { id: "RP-02", gruppe: "maschine", typ: "Rüttelplatte 500", kuerzel: "RP", kat: "Kleingerät" },
  { id: "RP-05", gruppe: "maschine", typ: "Rüttelplatte 500", kuerzel: "RP", kat: "Kleingerät" },
  { id: "TR-03", gruppe: "maschine", typ: "Trecker 120 PS", kuerzel: "TR", kat: "Landtechnik" },
  { id: "MU-01", gruppe: "maschine", typ: "Mulcher 2,8 m", kuerzel: "MU", kat: "Landtechnik" },
  /* Ein gezählter Bestand (Migration 0194, Lisas Pool-Wunsch vom 25.09.2026):
     sechzig Fahrbahnplatten, eine Zeile. */
  { id: "Fahrbahnplatte 3 × 1 m", gruppe: "maschine", typ: "Fahrbahnplatte 3 × 1 m", kuerzel: "FP", kat: "Kleingerät", bestand: 60 },
  { id: "M. Lenger", gruppe: "personal", typ: "Kranführer", kuerzel: "ML", qual: ["KRAN"], kat: "Personal" },
  { id: "T. Brand", gruppe: "personal", typ: "Fahrer", kuerzel: "TB", qual: ["CE"], kat: "Personal" },
  { id: "J. Kruse", gruppe: "personal", typ: "Fahrer", kuerzel: "JK", qual: ["CE", "KRAN"], kat: "Personal" },
  { id: "S. Ott", gruppe: "personal", typ: "Disponent", kuerzel: "SO", qual: [], kat: "Personal" },
  { id: "H. Wilts", gruppe: "personal", typ: "Wascher", kuerzel: "HW", qual: ["PSAgA"], kat: "Personal" },
];

/* Die Belegungen liegen in KW 19. Wer blättert, sieht andere Daten — und in
   anderen Wochen nichts, weil dort nichts erfunden wurde. Das ist ehrlicher
   als eine Woche, aus der man nicht herauskommt. */
export const BELEGUNGEN: Belegung[] = [
  { id: "b1", res: "RL-07", von: 0, bis: 4, kunde: "Bauer GmbH", geschaeft: "miete", fest: true, zustand: "laeuft", vorgang: "V-2026-0142", ort: "Baustelle Nordring", vonStd: 0, bisStd: 11 },
  { id: "b2", res: "RL-08", von: 0, bis: 2, kunde: "Meyer Bau", geschaeft: "miete", fest: false, zustand: "geplant", vorgang: "V-2026-0147", zusatz: "verfällt 06.05.", ort: "Lohne" },
  { id: "b3", res: "RL-08", von: 4, bis: 4, kunde: "Ahlers", geschaeft: "miete", fest: true, zustand: "geplant", vorgang: "V-2026-0155", ort: "Emstek" },
  { id: "b4", res: "RL-09", von: 0, bis: 0, kunde: "UVV-Prüfung", geschaeft: "sperre", fest: true, zustand: "geplant", grundArt: "wartung" },
  { id: "b5", res: "RL-09", von: 1, bis: 3, kunde: "Schulz KG", geschaeft: "miete", fest: true, zustand: "geplant", vorgang: "V-2026-0139", ort: "Vechta" },
  { id: "b6", res: "KR-01", von: 2, bis: 3, kunde: "Solarpark Nord", geschaeft: "leistung", fest: true, zustand: "geplant", vorgang: "V-2026-0151", mit: ["M. Lenger"], ort: "Garrel, Feld B", vonStd: 1, bisStd: 6 },
  { id: "b7", res: "M. Lenger", von: 2, bis: 3, kunde: "Solarpark Nord", geschaeft: "leistung", fest: true, zustand: "geplant", vorgang: "V-2026-0151", mit: ["KR-01"], ort: "Garrel, Feld B", vonStd: 1, bisStd: 6 },
  { id: "b8", res: "T. Brand", von: 0, bis: 0, kunde: "Bauer GmbH", geschaeft: "miete", fest: true, zustand: "laeuft", vorgang: "V-2026-0142", zusatz: "Transport", vonStd: 0, bisStd: 2 },
  { id: "b9", res: "T. Brand", von: 4, bis: 4, kunde: "Ahlers", geschaeft: "miete", fest: true, zustand: "geplant", vorgang: "V-2026-0155", zusatz: "Transport", vonStd: 7, bisStd: 9 },
  { id: "b10", res: "S. Ott", von: 0, bis: 4, kunde: "Urlaub", geschaeft: "sperre", fest: true, zustand: "geplant", grundArt: "urlaub" },
  { id: "b11", res: "RP-02", von: 1, bis: 2, kunde: "Schulz KG", geschaeft: "miete", fest: true, zustand: "geplant", vorgang: "V-2026-0139", ort: "Vechta" },
  { id: "b12", res: "RL-11", von: 0, bis: 3, kunde: "Ahlers Bau", geschaeft: "miete", fest: true, zustand: "laeuft", vorgang: "V-2026-0155", ort: "Emstek" },
  { id: "b13", res: "RL-21", von: 2, bis: 4, kunde: "Kruse GaLaBau", geschaeft: "miete", fest: false, zustand: "geplant", vorgang: "V-2026-0161", zusatz: "verfällt 09.05.", ort: "Garrel" },
  { id: "b14", res: "KR-02", von: 0, bis: 1, kunde: "Werkstatt", geschaeft: "sperre", fest: true, zustand: "geplant", grundArt: "wartung" },
  { id: "b15", res: "MS-11", von: 1, bis: 4, kunde: "Bauer GmbH", geschaeft: "miete", fest: true, zustand: "laeuft", vorgang: "V-2026-0142", ort: "Baustelle Nordring" },
  { id: "b16", res: "MS-14", von: 3, bis: 4, kunde: "Meyer Bau", geschaeft: "miete", fest: false, zustand: "geplant", vorgang: "V-2026-0165", zusatz: "unbestätigt", ort: "Lohne" },
  { id: "b17", res: "RP-05", von: 0, bis: 4, kunde: "Bauer GmbH", geschaeft: "miete", fest: true, zustand: "laeuft", vorgang: "V-2026-0142", zusatz: "UVV überfällig", ort: "Baustelle Nordring" },
  { id: "b18", res: "TR-03", von: 2, bis: 4, kunde: "Hempen Agrar", geschaeft: "miete", fest: true, zustand: "geplant", vorgang: "V-2026-0158", mit: ["MU-01", "J. Kruse"], ort: "Garrel" },
  { id: "b19", res: "MU-01", von: 2, bis: 4, kunde: "Hempen Agrar", geschaeft: "miete", fest: true, zustand: "geplant", vorgang: "V-2026-0158", mit: ["TR-03"], ort: "Garrel" },
  { id: "b20", res: "J. Kruse", von: 2, bis: 4, kunde: "Hempen Agrar", geschaeft: "miete", fest: true, zustand: "geplant", vorgang: "V-2026-0158", mit: ["TR-03"], ort: "Garrel" },
  { id: "b21", res: "H. Wilts", von: 2, bis: 3, kunde: "Solarpark Nord", geschaeft: "leistung", fest: true, zustand: "geplant", vorgang: "V-2026-0151", mit: ["KR-01"], ort: "Garrel, Feld B" },
  /* Zwei, die über das Fenster hinausgehen (25.09.2026): Der Autokran läuft
     bis in die nächste Woche, die Rüttelplatte kam schon in der letzten. An
     ihnen sieht man den Pfeil zum echten Ende und das Weiterblättern beim
     Ziehen. Die Spalten zählen Werktage ab dem Fenster, auch negativ. */
  { id: "b25", res: "KR-02", von: 3, bis: 7, kunde: "Lüken Hochbau", geschaeft: "miete", fest: true, zustand: "geplant", ort: "Friesoythe" },
  { id: "b26", res: "RP-02", von: -3, bis: 0, kunde: "Wendeln Tiefbau", geschaeft: "miete", fest: true, zustand: "laeuft", ort: "Lastrup" },
  /* Der Pool: zwanzig Platten Mo–Mi, fünfundzwanzig Mi–Fr, zehn vorgemerkt. */
  { id: "b22", res: "Fahrbahnplatte 3 × 1 m", menge: 20, von: 0, bis: 2, kunde: "Bauer GmbH", geschaeft: "miete", fest: true, zustand: "laeuft", vorgang: "V-2026-0142", ort: "Baustelle Nordring" },
  { id: "b23", res: "Fahrbahnplatte 3 × 1 m", menge: 25, von: 2, bis: 4, kunde: "Hempen Agrar", geschaeft: "miete", fest: true, zustand: "geplant", vorgang: "V-2026-0158", ort: "Garrel" },
  { id: "b24", res: "Fahrbahnplatte 3 × 1 m", menge: 10, von: 3, bis: 4, kunde: "Kruse GaLaBau", geschaeft: "miete", fest: false, zustand: "geplant", vorgang: "V-2026-0161", zusatz: "verfällt 09.05.", ort: "Garrel" },
];

export const VORGAENGE: Vorgang[] = [
  { nr: "V-2026-0142", kunde: "Bauer GmbH", was: "Radlader 5 t", ort: "Baustelle Nordring", von: "04.05.", bis: "24.05.", zustand: "läuft", vorbereitung: "fertig", art: "gut", grundlage: "monatlich", netto: null, ampeln: [], schaeden: [] },
  { nr: "V-2026-0139", kunde: "Schulz KG", was: "Rüttelplatte 500", ort: "Vechta", von: "05.05.", bis: "07.05.", zustand: "läuft", vorbereitung: "fertig", art: "gut", grundlage: "einmalig", netto: null, ampeln: [], schaeden: [] },
  { nr: "V-2026-0158", kunde: "Hempen Agrar", was: "Trecker 120 PS mit Mulcher", ort: "Garrel", von: "06.05.", bis: "08.05.", zustand: "läuft", vorbereitung: "fertig", art: "gut", grundlage: "einmalig", netto: null, ampeln: [], schaeden: [] },
  { nr: "V-2026-0151", kunde: "Solar Nord GmbH", was: "PV-Reinigung", ort: "Solarpark Nord · Feld B", von: "12.05.", bis: "14.05.", zustand: "angenommen", vorbereitung: "laeuft", art: "", grundlage: "einmalig", netto: null, ampeln: [], schaeden: [] },
  { nr: "V-2026-0161", kunde: "Kruse GaLaBau", was: "Mulchen · 14 ha", ort: "Garrel", von: "18.05.", bis: "20.05.", zustand: "angenommen", vorbereitung: "fertig", art: "", grundlage: "einmalig", netto: null, ampeln: [], schaeden: [] },
  { nr: "V-2026-0155", kunde: "Ahlers Bau & Tief", was: "Radlader 5 t", ort: "Emstek", von: "01.05.", bis: "03.05.", zustand: "zurueck", vorbereitung: "fertig", art: "acht", grundlage: "einmalig", zutun: "Schaden im Protokoll — Entscheidung fehlt", netto: null, ampeln: [],
    /* **Der Schaden stand im Text und nicht in den Daten** (22.09.2026).
       `zutun` nannte ihn, `schaeden` war leer — und damit fehlte in der
       Pruefliste ausgerechnet der Punkt, an dem die Freigabe haengt. */
    schaeden: [{ protokollId: "p-0155-r", text: "Kratzer linker Kotflügel, oberflächlich", ressource: "RL-11", verschulden: null }] },
  { nr: "V-2026-0129", kunde: "Kruse GaLaBau", was: "Rüttelplatte 500", ort: "Garrel", von: "22.04.", bis: "25.04.", zustand: "zurueck", vorbereitung: "fertig", art: "acht", grundlage: "einmalig", zutun: "Mehrstunden über Freikontingent — freigeben?", netto: null, ampeln: [], schaeden: [] },
  { nr: "V-2026-0126", kunde: "Schulz KG", was: "Minibagger 1,8 t", ort: "Vechta", von: "15.04.", bis: "17.04.", zustand: "bereit", vorbereitung: "fertig", art: "", grundlage: "einmalig", netto: null, ampeln: [], schaeden: [] },
  { nr: "V-2026-0138", kunde: "Meyer Bau", was: "Minibagger 1,8 t", ort: "Lohne", von: "20.04.", bis: "28.04.", zustand: "abgerechnet", vorbereitung: "fertig", art: "", grundlage: "einmalig", netto: null, ampeln: [], schaeden: [] },
  { nr: "V-2026-0148", kunde: "Wendeln Hoch- und Tiefbau", was: "Minibagger 1,8 t", ort: "Lastrup", von: "28.04.", bis: "30.04.", zustand: "storniert", art: "", grundlage: "einmalig", grund: "Kunde abgesprungen", netto: null, ampeln: [], schaeden: [] },
];

/* Zwei je Belegung: Ausgabe und Rücknahme. Was hier steht, kam vom Handy
   des Fahrers — Zählerstände, Zustand, Fotos, Unterschrift. */
/* **`stunden` ist eine Zahl zum Rechnen, kein Text zum Lesen** (18.09.2026).
   Hier stand `"1.284,5 h"` — fertig gesetzt, mit Tausenderpunkt und Einheit.
   `alsProtokoll()` in `routen.ts` liefert aber `String(operating_hours)`, also
   `"1284.5"`, und jede Maske rechnet damit: Die Zusammenfassung am Telefon
   zeigte „NaN h", und die Rücknahme bekam keinen Ausgabestand vorgelegt. Die
   Attrappe liefert dieselbe Form wie die API — sonst prüft man eine, die es
   nicht gibt. */
export const PROTOKOLLE: Record<string, Protokolle> = {
  "V-2026-0155": {
    ausgabe: { wann: "01.05.2026, 07:12", wer: "T. Brand", wo: "Betriebshof Cloppenburg", stunden: "1284.5", tank: "100 %", zustand: "ohne Beanstandung", schaden: null, unterschrift: "B. Ahlers", art: "vor Ort unterschrieben" },
    ruecknahme: { wann: "03.05.2026, 16:40", wer: "T. Brand", wo: "Betriebshof Cloppenburg", stunden: "1301", tank: "40 %", zustand: "gebraucht", schaden: "Kratzer linker Kotflügel, oberflächlich", unterschrift: "B. Ahlers", art: "vor Ort unterschrieben" },
    istStunden: null,
  },
  "V-2026-0142": {
    ausgabe: { wann: "04.05.2026, 06:55", wer: "T. Brand", wo: "Baustelle Nordring", stunden: "2140", tank: "100 %", zustand: "ohne Beanstandung", schaden: null, unterschrift: "H. Bauer", art: "vor Ort unterschrieben" },
    ruecknahme: null,
    istStunden: null,
  },
};

/* ══════════════ Maschinen und Protokollzeilen ══════════════

   **Damit der Laufzettel im Prototyp etwas zu zeigen hat** (22.09.2026).
   `PROTOKOLLE` oben trägt die beiden Eckprotokolle je Vorgang; der Laufzettel
   braucht sie aber **je Belegung** und mit Kennung — er hängt an der Belegung
   und nicht am Vorgang, weil nach einem Gerätetausch jede Maschine ihren
   eigenen Zähler führt.

   V-2026-0155 ist der reiche Fall: zwei Geräte, beide zurück, ein Schaden
   ohne Entscheidung und eine Rücknahme ohne Unterschrift. Genau daran ist die
   Prüfliste zu sehen. V-2026-0142 läuft noch — dort steht die Rücknahme aus,
   und der Laufzettel zeigt den geplanten Tag statt eines Wertes (Regel 3). */
export const MASCHINENSTAND: Record<string, Maschinenstand[]> = {
  "V-2026-0155": [
    { id: "b12", name: "RL-11", stand: "zurueck", typ: "Radlader 5 t", von: "01.05.", bis: "03.05.", zurueckAm: "03.05." },
    { id: "b9", name: "TL-02", stand: "zurueck", typ: "Tieflader 3-Achs", von: "01.05.", bis: "03.05.", zurueckAm: "03.05." },
  ],
  "V-2026-0142": [
    { id: "b1", name: "RL-08", stand: "laeuft", typ: "Radlader 5 t", von: "04.05.", bis: "24.05.", seit: "04.05." },
  ],
  /* **Der bediente Einsatz** (22.09.2026). Luca: *„Wenn es einen
     Vor-Ort-Einsatz mit Bediener gab, wie sieht das dann aus?"* — Bei der
     Übergabe unterschreibt niemand; der Kunde quittiert am Tagesende. Die
     API lässt Unterschrift UND Grund leer (`routen/protokolle.ts`,
     `mitBediener`), und der Laufzettel muss das als Zustand lesen und nicht
     als Lücke. Der Fall gehört in die Attrappe, sonst prüft ihn niemand. */
  "V-2026-0151": [
    { id: "b6", name: "KR-01", stand: "laeuft", typ: "Autokran 30 t", von: "12.05.", bis: "14.05.", seit: "12.05.", positionId: "p-0151-1" },
  ],
};

export const PROTOKOLLZEILEN: Record<string, ProtokollZeile[]> = {
  "V-2026-0155": [
    {
      id: "p-0155-a", belegungId: "b12", ressource: "RL-11", art: "ausgabe",
      wann: "01.05. 07:12", wannIso: "2026-05-01T07:12:00+02:00", wer: "T. Brand",
      wo: "Betriebshof Cloppenburg", stunden: "1284.5", tank: "100 %",
      zustand: "ohne Beanstandung", schaden: null, unterschrift: "B. Ahlers",
      km: null, korrekturen: 0, letzterGrund: null, spur: [], inhalt: null, bestaetigung: null,
    },
    {
      id: "p-0155-r", belegungId: "b12", ressource: "RL-11", art: "ruecknahme",
      wann: "03.05. 16:40", wannIso: "2026-05-03T16:40:00+02:00", wer: "T. Brand",
      wo: "Betriebshof Cloppenburg", stunden: "1301", tank: "40 %",
      zustand: "gebraucht", schaden: "Kratzer linker Kotflügel, oberflächlich",
      unterschrift: "", unterschriftGrund: "Kunde war nicht vor Ort, Gerät stand am Tor.",
      km: null, korrekturen: 1, letzterGrund: "Zählerstand verlesen",
      spur: [{ wann: "03.05.2026, 17:05", grund: "Zählerstand verlesen", felder: [{ feld: "operating_hours", vorher: "1310", nachher: "1301" }] }],
      inhalt: null, bestaetigung: null,
    },
    {
      id: "p-0155-ta", belegungId: "b9", ressource: "TL-02", art: "ausgabe",
      wann: "01.05. 06:40", wannIso: "2026-05-01T06:40:00+02:00", wer: "T. Brand",
      wo: "Betriebshof Cloppenburg", km: "84210", zustand: "ohne Beanstandung",
      schaden: null, unterschrift: "B. Ahlers",
      korrekturen: 0, letzterGrund: null, spur: [], inhalt: null, bestaetigung: null,
    },
    {
      id: "p-0155-tr", belegungId: "b9", ressource: "TL-02", art: "ruecknahme",
      wann: "03.05. 17:20", wannIso: "2026-05-03T17:20:00+02:00", wer: "T. Brand",
      wo: "Betriebshof Cloppenburg", km: "84298", zustand: "ohne Beanstandung",
      schaden: null, unterschrift: "B. Ahlers",
      korrekturen: 0, letzterGrund: null, spur: [], inhalt: null, bestaetigung: null,
    },
  ],
  "V-2026-0151": [
    {
      id: "p-0151-a", belegungId: "b6", ressource: "KR-01", art: "ausgabe",
      wann: "12.05. 06:40", wannIso: "2026-05-12T06:40:00+02:00", wer: "M. Lenger",
      wo: "Solarpark Nord · Feld B", stunden: "3812.0", tank: "100 %",
      zustand: "ohne Beanstandung", schaden: null, unterschrift: "",
      km: null, korrekturen: 0, letzterGrund: null, spur: [], inhalt: null, bestaetigung: null,
    },
  ],
  "V-2026-0142": [
    {
      id: "p-0142-a", belegungId: "b1", ressource: "RL-08", art: "ausgabe",
      wann: "04.05. 06:55", wannIso: "2026-05-04T06:55:00+02:00", wer: "T. Brand",
      wo: "Baustelle Nordring", stunden: "2140", tank: "100 %",
      zustand: "ohne Beanstandung", schaden: null, unterschrift: "H. Bauer",
      km: null, korrekturen: 0, letzterGrund: null, spur: [], inhalt: null, bestaetigung: null,
    },
  ],
};

export const ANGEBOTE: Angebot[] = [
  { nr: "AG-2026-0044", kunde: "Solar Nord GmbH", was: "PV-Reinigung · Feld B", gestellt: "02.09.", frist: "19.09.", phase: "versendet", tage: 6, res: "KR-01", bel: "b6", netto: null },
  { nr: "AG-2026-0041", kunde: "Meyer Bau", was: "Radlader 5 t · 3 Wochen", gestellt: "28.08.", frist: "11.09.", phase: "versendet", tage: 11, eilt: true, res: "RL-08", bel: "b2", netto: null },
  { nr: "AG-2026-0039", kunde: "Kruse GaLaBau", was: "Mulchen · 14 ha", gestellt: "21.08.", frist: "04.09.", phase: "angenommen", tage: null, res: "RL-21", bel: "b13", netto: null },
  { nr: "AG-2026-0036", kunde: "Hempen Agrar", was: "Trecker mit Mulcher", gestellt: "14.08.", frist: "28.08.", phase: "abgelehnt", tage: null, grund: "Preis zu hoch", netto: null },
  { nr: "—", kunde: "Bauer GmbH", was: "Minibagger · Dauermiete ab Oktober", gestellt: "—", frist: "—", phase: "entwurf", tage: null, netto: null },
  /* **Zwei Entwürfe mit Ortsaufnahme** (Befund 40, 25.09.2026) — dieselben
     Vorgänge wie in `attrappe/aufnahmen.ts`: An 0052 hängt eine nur bestellte
     Aufnahme mit Termin (Verwerfen geht, die Rückfrage nennt sie), an 0051
     eine durchgeführte (Verwerfen ist gesperrt, der Satz nennt ihren Tag).
     Was daran hängt, liest `angeboteListe` aus dem Stand der Aufnahmen. */
  { nr: "AG-2026-0052", kunde: "Solarpark Emsland Betriebs GmbH", was: "PV-Reinigung · Feld Nord, Erstreinigung", gestellt: "—", frist: "—", phase: "entwurf", tage: null, netto: null },
  { nr: "AG-2026-0051", kunde: "Solarpark Emsland Betriebs GmbH", was: "PV-Reinigung · Feld Süd, Frühjahrsreinigung", gestellt: "—", frist: "—", phase: "entwurf", tage: null, netto: null },
];

export const POSITIONEN: Position[] = [
  { id: "p-0151-1", nr: 1, was: "PV-Reinigung, Modulfläche", bei: "3.000-l-Tank enthalten · Strom vom Kran", artikel: "PV-REIN-QM", menge: "2.400,00", einheit: "m²", einzel: null, summe: null, bedient: true, bedienungspflicht: "nur_mit_person" },
  { nr: 2, was: "Autokran mit Waschausleger, bedient", bei: "Kranführer im Preis enthalten", artikel: "KR-WASCH-TAG-B", menge: "3,00", einheit: "Tage", einzel: null, summe: null },
  { nr: 3, was: "Transport hin und zurück", bei: "Betriebshof Cloppenburg → Solarpark Nord, Feld B · 64 km einfach · ab km 1", artikel: "TRANS-KM", menge: "128,00", einheit: "km", einzel: null, summe: null },
];

/* Der gespiegelte Kundenstamm. Er liegt hier, nicht drüben — es gibt kein
   „in Lexware nachschlagen" (21-stammdaten.md, Abschnitt 5).

   **Die Nummern tragen seit dem 16.09.2026 keinen Vorsatz mehr** (Migration
   0064): Es ist dieselbe Nummer wie in Lexware Office, und dort ist sie eine
   blanke Ziffernfolge. Der Interessent trägt eine wie jeder andere — die
   Attrappe behauptete bis hierhin „—", die API hat auch vorher schon eine
   vergeben. */
/* ══════════════ Der Kundenstamm trägt jetzt eine Akte ══════════════

   *Ergänzt am 18.09.2026, abends.* Bis dahin standen hier sieben Zeilen mit
   Name, Ort, Nummer und Zahlungsziel — genug für eine Liste und zu wenig für
   eine Akte. Die Kundenakte hat an diesem Abend einen **Überblick** bekommen
   (`masken/kunden/Kurzakte.tsx`): ein Satz oben („Letzter Kontakt heute. Zwei
   Vorgänge offen. Ansprechpartner ist …"), eine Griffreihe zum Anrufen, zur
   Route und zur Mail, ein Auszug der letzten Notizen und Vorgänge, getrennt
   nach offen und erledigt.

   **Im Prototyp war davon nichts zu sehen**, weil hier weder Telefon noch
   Anschrift, weder Ansprechpartner noch Vorgänge standen — und
   `kundennotizen()` gab eine leere Liste zurück. Wer nach
   `docs/29-pruefauftrag.md` durchklickt, sah also den Leerfall der Maske, an
   der am meisten passiert ist.

   **Zwei Kunden sind ausgebaut, nicht alle sieben.** Bauer GmbH trägt den
   vollen Fall; Solar Nord GmbH einen zweiten, schlankeren — genug, um zu
   sehen, dass die Maske mit unterschiedlich viel umgeht. Die übrigen bleiben
   dünn, und das ist ebenso ein Fall: Eine Akte ohne Ansprechpartner sagt
   „Kein Ansprechpartner hinterlegt", und auch das will man einmal gesehen
   haben.

   **Jeder Einsatzort trägt eine `uuid`.** Ohne sie lässt sich „Bearbeiten"
   an einem Ort gar nicht öffnen, und React hat für die Liste keinen
   stabilen Schlüssel (`masken/kunden/Einsatzorte.tsx`).

   > **⚠ Keine Zahl hier ist ein Preis.** Beträge stehen als `null`, solange
   > die Kalkulation aus `04-preisfindung.md` nicht durchgeführt ist. Die
   > Entfernungen, Nummern und Zeiträume sind Beispielwerte. */
export const KUNDENSTAMM: Kunde[] = [
  {
    name: "Bauer GmbH", ort: "Cloppenburg", nr: "10012", art: "kunde",
    ansprechpartner: "H. Klaassen", zahlungsziel: "14", offen: "gut",
    seit: "03/2021", drueben: true, abgeglichen: "18.09.2026, 08:15",
    telefon: "+49 4471 88120",
    rechnungEmail: "rechnung@bauer-bau.de",
    ustId: "DE267451903",
    anschrift: { strasse: "Emsteker Straße 42", plz: "49661", ort: "Cloppenburg", land: "DE" },
    leute: [
      { id: "ap-1", name: "Heiner Klaassen", funktion: "Bauleiter", telefon: "+49 4471 88121", mobil: "+49 171 2233445", email: "klaassen@bauer-bau.de", haupt: true },
      { id: "ap-2", name: "Antje Bauer", funktion: "Geschäftsführung", telefon: "+49 4471 88110", email: "a.bauer@bauer-bau.de", haupt: false },
      { id: "ap-3", name: "Timo Rüther", funktion: "Polier Nordring", mobil: "+49 160 5544332", haupt: false },
    ],
    /* Drei Vorgänge, und der Schnitt daran ist der Punkt: zwei offene und
       einer, der durch ist. Der Satz oben zählt die offenen, der Reiter
       „Vorgänge" trennt danach. */
    vorgaenge: [
      { nr: "V-2026-0142", zustand: "läuft", art: "gut", was: "Radlader 5 t · Baustelle Nordring", wann: "04.05." },
      { nr: "V-2026-0168", zustand: "angenommen", art: "", was: "Minibagger 1,8 t · Dauermiete", wann: "15.09." },
      { nr: "V-2026-0104", zustand: "abgerechnet", art: "", was: "Rüttelplatte 500 · eine Woche", wann: "12.03." },
    ],
    orte: [
      { uuid: "o-1001", id: "O-0001", name: "Baustelle Nordring", wo: "49661 Cloppenburg", km: "6",
        strasse: "Nordring 18", plz: "49661", ort: "Cloppenburg", standard: true, aktiv: true,
        zufahrt: "Einfahrt über den Wirtschaftsweg, Bauzaun mit Schloss — Schlüssel beim Polier." },
      { uuid: "o-1002", id: "O-0002", name: "Betriebshof Bauer", wo: "49661 Cloppenburg", km: "4",
        strasse: "Emsteker Straße 42", plz: "49661", ort: "Cloppenburg", aktiv: true },
    ],
  },
  { name: "Schulz KG", ort: "Vechta", nr: "10031", art: "kunde", zahlungsziel: "30", offen: "gut",
    telefon: "+49 4441 77340",
    anschrift: { strasse: "Falkenweg 9", plz: "49377", ort: "Vechta", land: "DE" },
    vorgaenge: [{ nr: "V-2026-0139", zustand: "läuft", art: "gut", was: "Rüttelplatte 500", wann: "05.05." }],
    orte: [{ uuid: "o-1003", id: "O-0003", name: "Baustelle Falkenweg", wo: "49377 Vechta", km: "22", aktiv: true }] },
  { name: "Ahlers Bau & Tief", ort: "Emstek", nr: "10008", art: "kunde", zahlungsziel: "14", offen: "stopp",
    orte: [{ uuid: "o-1004", id: "O-0004", name: "Gewerbegebiet Emstek", wo: "49685 Emstek", km: "11", aktiv: true }] },
  { name: "Meyer Bau", ort: "Lohne", nr: "10044", art: "kunde", zahlungsziel: "14", offen: "acht",
    telefon: "+49 4442 123456", orte: [] },
  { name: "Kruse GaLaBau", ort: "Garrel", nr: "10052", art: "kunde", zahlungsziel: "14", offen: "gut",
    orte: [{ uuid: "o-1005", id: "O-0005", name: "Feld Beverbruch", wo: "49681 Garrel", km: "14", aktiv: true }] },
  {
    name: "Solar Nord GmbH", ort: "Oldenburg", nr: "10019", art: "kunde",
    ansprechpartner: "H. Klaassen", zahlungsziel: "30", offen: "gut",
    seit: "07/2024", drueben: true,
    telefon: "+49 441 998877",
    rechnungEmail: "buchhaltung@solar-nord.de",
    anschrift: { strasse: "Donnerschweer Straße 210", plz: "26123", ort: "Oldenburg", land: "DE" },
    leute: [
      { id: "ap-4", name: "Britta Ostendorf", funktion: "Technische Leitung", telefon: "+49 441 998870", email: "ostendorf@solar-nord.de", haupt: true },
    ],
    vorgaenge: [
      { nr: "V-2026-0151", zustand: "angenommen", art: "", was: "PV-Reinigung · Feld B", wann: "12.05." },
      { nr: "V-2025-0288", zustand: "abgerechnet", art: "", was: "PV-Reinigung · Feld A", wann: "09.09." },
    ],
    orte: [
      { uuid: "o-1006", id: "O-0006", name: "Solarpark Nord, Feld A", wo: "49681 Garrel", km: "64", art: "pv_freiflaeche", aktiv: true },
      { uuid: "o-1007", id: "O-0007", name: "Solarpark Nord, Feld B", wo: "49681 Garrel", km: "64", art: "pv_freiflaeche", aktiv: true },
    ],
  },
  /* Der Kunde der Ortsaufnahmen (`attrappe/aufnahmen.ts`). Er steht hier,
     damit die Zeilen dort auf einen Kunden zeigen, den es im Prototyp
     wirklich gibt — sonst führt die Begehung in eine Akte, die leer ist. */
  {
    name: "Solarpark Emsland Betriebs GmbH", ort: "Haren", nr: "10041", art: "interessent",
    zahlungsziel: "30", offen: "gut",
    telefon: "+49 5932 72180",
    anschrift: { strasse: "Am Wasserwerk 3", plz: "49733", ort: "Haren (Ems)", land: "DE" },
    leute: [
      { id: "ap-5", name: "Herr Tebben", funktion: "Betriebsführung", mobil: "+49 170 6677889", haupt: true },
    ],
    vorgaenge: [
      { nr: "AG-2026-0051", zustand: "angebot", art: "", was: "PV-Reinigung · Feld Süd", wann: "14.09." },
      { nr: "AG-2026-0052", zustand: "entwurf", art: "", was: "PV-Reinigung · Feld Nord", wann: "16.09." },
    ],
    orte: [
      { uuid: "o-1008", id: "SPE-1", name: "Solarpark Emsland — Feld Süd", wo: "49733 Haren", km: "18", art: "pv_freiflaeche", aktiv: true },
      { uuid: "o-1009", id: "SPE-2", name: "Solarpark Emsland — Feld Nord", wo: "49733 Haren", km: "18", art: "pv_freiflaeche", aktiv: true },
    ],
  },
  { name: "Hempen Agrar GmbH", ort: "Garrel", nr: "10061", art: "interessent", orte: [] },
];

/* Die drei Zahlungsziele des Betriebs — Tage, kein Betrag. Sie stehen in
   `stammKataloge()`, weil das Feld in der Kundenakte sie sonst nicht findet
   und „14 Tage — nicht in der Liste" schreibt. */
export const ZAHLUNGSZIELE: Zahlungsziel[] = [
  { id: "zz-1", label: "Sofort netto", tage: 0, standard: false, sortierung: 1, aktiv: true, kunden: 0 },
  { id: "zz-2", label: "14 Tage netto", tage: 14, standard: true, sortierung: 2, aktiv: true, kunden: 4 },
  { id: "zz-3", label: "30 Tage netto", tage: 30, standard: false, sortierung: 3, aktiv: true, kunden: 3 },
];

/* ══════════════ Der Verlauf am Kunden ══════════════

   *Ergänzt am 18.09.2026.* `kundennotizen()` gab im Prototyp eine leere
   Liste zurück — damit stand in der Akte weder „Letzter Kontakt heute" noch
   der Abschnitt „Zuletzt besprochen", und die Auskunft „3 von 5" hatte
   nichts zu zählen.

   **Die Zeitpunkte werden gerechnet, nicht geschrieben.** Ein festes Datum
   wäre nach einer Woche „vor neun Tagen", und der Satz oben sagte „Letzter
   Kontakt vor 9 Tagen" bei einem Kunden, bei dem gerade jemand war. Die
   Maske liest den Tag aus dem fertigen Text zurück (`Kurzakte.tsx`,
   `TAGMUSTER`) — deshalb steht hier dieselbe Form wie aus der API:
   `18.09.2026, 11:35`. */
function vorTagen(tage: number, uhr: string): string {
  const d = new Date();
  d.setDate(d.getDate() - tage);
  const zz = (n: number) => String(n).padStart(2, "0");
  return `${zz(d.getDate())}.${zz(d.getMonth() + 1)}.${d.getFullYear()}, ${uhr}`;
}

export const KUNDENNOTIZEN: Record<string, Kundennotiz[]> = {
  "10012": [
    { id: "n-1", wann: vorTagen(0, "08:40"), art: "telefonat", art_schluessel: "texte.art.telefonat",
      verfasser: "Lisa Meyer", kuerzel: "LM",
      text: "Herr Klaassen ruft an: Der Radlader bleibt bis Monatsende auf dem Nordring. "
        + "Verlängerung ist im Vorgang eingetragen." },
    { id: "n-2", wann: vorTagen(2, "16:05"), art: "vermerk", art_schluessel: "texte.art.vermerk",
      verfasser: "Lisa Meyer", kuerzel: "LM",
      text: "Besuch auf der Baustelle. Für Oktober fragt er einen Minibagger als Dauermiete an — "
        + "Angebot ist zugesagt." },
    { id: "n-3", wann: vorTagen(9, "10:12"), art: "vermerk", art_schluessel: "texte.art.vermerk",
      verfasser: "S. Ott", kuerzel: "SO",
      text: "Zufahrt Nordring ist seit dem Regen weich. Für den Radlader Breitreifen mitgeben." },
    { id: "n-4", wann: vorTagen(24, "09:00"), art: "telefonat", art_schluessel: "texte.art.telefonat",
      verfasser: "S. Ott", kuerzel: "SO",
      text: "Rückfrage zur Rechnung V-2026-0104. Position „Transport“ war ihm unklar, erklärt." },
    /* Eine Systemzeile ohne Text: Sie steht im Verlauf, zählt aber nicht als
       Kontakt — die Maske filtert auf `text` (`Kurzakte.tsx`). Genau dafür
       steht sie hier: damit der Unterschied einmal zu sehen ist. */
    { id: "n-5", wann: vorTagen(24, "08:58"), art: "system", art_schluessel: "texte.art.system",
      verfasser: "Lexware Office", kuerzel: "LX",
      spur: [{ feld: "payment_terms", vorher: "30 Tage", nachher: "14 Tage" }] },
  ],
  "10019": [
    { id: "n-6", wann: vorTagen(1, "14:20"), art: "telefonat", art_schluessel: "texte.art.telefonat",
      verfasser: "Lisa Meyer", kuerzel: "LM",
      text: "Frau Ostendorf: Feld B soll im Mai gewaschen werden, Feld A erst im Herbst wieder." },
    { id: "n-7", wann: vorTagen(31, "11:35"), art: "vermerk", art_schluessel: "texte.art.vermerk",
      verfasser: "H. Wilts", kuerzel: "HW",
      text: "Wasser ist am Trafohaus vorhanden, Strom ebenfalls. Kein eigener Tank nötig." },
  ],
  "10041": [
    { id: "n-8", wann: vorTagen(4, "17:40"), art: "vermerk", art_schluessel: "texte.art.vermerk",
      verfasser: "Lisa Meyer", kuerzel: "LM",
      text: "Feld Süd aufgenommen: 1.240 m², starke Verschmutzung durch den angrenzenden Maisacker. "
        + "Beispielwerte — der Satz je m² steht noch nicht fest." },
  ],
};

export const EINSTELLUNGEN: Einstellungen = {
  firma: "Mr. Machine",
  rechtsform: "GmbH",
  strasse: "Industriestraße 14",
  plz: "49661",
  ort: "Cloppenburg",
  land: "",
  ust_id: "DE —",
  steuernummer: "",
  telefon: "",
  email: "",
  web: "",
  wetter_ort: "Cloppenburg",
  wetter_orte: ["Cloppenburg", "Garrel", "Vechta", "Lastrup"],
  kalender: {
    vorgabe_kalender: "5-Tage",
  },
  // Beispiel aus dem Gespräch vom 16.09.2026, keine gesetzte Zahl.
  stunden_je_tag: 8,
  uebergabe_mit_fahrer: false,
  qualifikation: "warnen",
  nachtanken_zuteilung: "ruecknahme",
  // In der Attrappe zieht nichts einen Beleg — es gibt kein Lexware dahinter.
  positionstexte: {},
  // Lucas Standard (0173): vorne, hinten, links, rechts, Tank — in allen drei Protokollen.
  pflichtfotos: {
    vorbereitung: ["vorne", "hinten", "links", "rechts", "tank"],
    ausgabe: ["vorne", "hinten", "links", "rechts", "tank"],
    ruecknahme: ["vorne", "hinten", "links", "rechts", "tank"],
  },
  vorbereitung_vorlauf_tage: 1,
  vorbereitung_uhrzeit: "06:00",
  // Die Vorgabe aus 0286 — Beispiele, die der Betrieb anpasst.
  vorabend_ab: "16:00",
  morgen_bis: "08:00",
  // Keine Abweichung je Wochentag (0288).
  vorabend_je_tag: {},
  // Leer: das Land aus der Postleitzahl (0287).
  feiertagsland: null,
  // Leer heißt aus, und leer bleibt sie: In die Attrappe gehört kein Betrag,
  // den niemand gerechnet hat (0138, G8).
  mindestauftrag: null,
};

/** Ein Mensch ohne Anmeldung ist der Normalfall für Fahrer: `email: null`. */
const benutzer = (
  id: string, name: string, kuerzel: string, rollen: Rolle[],
  mfa: Benutzer["mfa"], zustand: Benutzer["zustand"], email: string | null,
): Benutzer => ({
  id, name, kuerzel, rollen, mfa, zustand, email,
  passwortwechsel: zustand === "wechsel_faellig" ? "naechste_anmeldung" : "nicht_noetig",
  personalnummer: "",
  disponierbar: true,
  mfa_pflicht: mfa === "aktiv" || mfa === "einzurichten",
  ausgeschieden_am: zustand === "gesperrt" ? "2026-09-01" : null,
});

export const BENUTZER: Benutzer[] = [
  benutzer("u-001", "Lisa Meyer", "LM", ["disposition", "buchhaltung", "verwaltung"], "aktiv", "", "lisa@mr-machine.de"),
  benutzer("u-002", "L. Sliwinski", "LS", ["verwaltung"], "aktiv", "", "luca@mr-machine.de"),
  benutzer("u-003", "M. Lenger", "ML", ["aussendienst"], "nicht_verlangt", "", "m.lenger@mr-machine.de"),
  benutzer("u-004", "T. Brand", "TB", ["aussendienst"], "nicht_verlangt", "wechsel_faellig", "t.brand@mr-machine.de"),
  benutzer("u-005", "S. Ott", "SO", ["disposition"], "kein_konto", "eingeladen", null),
];

/* Die Job-Historie. Ein Lauf, der nichts gefunden hat, ist auch ein Lauf —
   er steht hier, damit man sieht, dass er lief. */
export const JOBS: Job[] = [
  { id: "j-2041", art: "abrechnung", begonnen: "05.05.2026, 06:00", dauer_sekunden: 12, ausgang: "teils", schritte: [
    { wann: "06:00:01", stufe: "gut", was_key: "Lauf begonnen", dazu: "Zeitraum 27.04.–03.05." },
    { wann: "06:00:03", stufe: "gut", was_key: "37 Vorgänge gesammelt" },
    { wann: "06:00:07", stufe: "acht", was_key: "3 Belege blockiert", dazu: "Protokoll fehlt · Kunde gesperrt" },
    { wann: "06:00:12", stufe: "gut", was_key: "Vorschlag abgelegt", dazu: "keine Rechnung geschrieben — Regel 1" },
  ] },
  { id: "j-2040", art: "lex_kunden", begonnen: "05.05.2026, 05:30", dauer_sekunden: 4, ausgang: "gut", schritte: [
    { wann: "05:30:00", stufe: "gut", was_key: "Abgleich begonnen" },
    { wann: "05:30:04", stufe: "gut", was_key: "142 Kontakte gespiegelt", dazu: "2 neu, 5 geändert" },
  ] },
  { id: "j-2039", art: "lex_artikel", begonnen: "05.05.2026, 05:30", dauer_sekunden: 6, ausgang: "stopp", schritte: [
    { wann: "05:30:00", stufe: "gut", was_key: "Abgleich begonnen" },
    { wann: "05:30:05", stufe: "stopp", was_key: "TRANS-KM fehlt drüben", dazu: "Der Artikel ist in Lexware gelöscht worden." },
    { wann: "05:30:06", stufe: "stopp", was_key: "Abgebrochen", dazu: "148 Artikel geprüft, 1 Abweichung" },
  ] },
  { id: "j-2038", art: "erinnerung", begonnen: "04.05.2026, 07:00", dauer_sekunden: 2, ausgang: "gut", schritte: [
    { wann: "07:00:00", stufe: "gut", was_key: "Lauf begonnen" },
    { wann: "07:00:02", stufe: "gut", was_key: "Nichts zu erinnern", dazu: "keine Frist läuft in den nächsten 3 Tagen ab" },
  ] },
];
